/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useState, useRef ,useEffect, Fragment} from "react";

const OtpInputField = ({ numInputs,inputs,setInputs,error,seterror }) => {
    const refs = useRef([]);
    const firstInputRef = useRef(null);


    const handleChange = (e, index) => {
        let value = e.target.value;
        value = value.split("").at(-1)
        setInputs((prevInputs) => {
            const newInputs = [...prevInputs];
            newInputs[index] = value;
            return newInputs;
        });
      
        if (value.length === 1 && index < numInputs - 1) {
            const nextInput = refs.current[index + 1];
            nextInput.focus();

        }
    };
  
    const getNextEmptyInput = (startIndex) => {
        for (let i = startIndex; i < numInputs; i++) {
            if (refs.current[i].value.length === 0) {
                return refs.current[i];
            }
        }
        return null;
    };
      
      
    useEffect(() => {
        // Focus on the first input field when the component mounts
        if (firstInputRef.current) {
            firstInputRef.current.focus();
        }
    }, []);

    const handlePaste = (e) => {
        e.preventDefault();
        const pastedData = e.clipboardData.getData("text");
        const pastedChars = pastedData.split("").slice(0, numInputs);
        setInputs(pastedChars);

        if (pastedChars.length > 0) {
            refs.current[pastedChars.length - 1].focus();
        }
    };
    const handleKeyDown = (e, index) => {
        if (e.keyCode === 8) {
            // Handle backspace key
            if (index > 0 && inputs[index] === "") {
                refs.current[index - 1].focus();
                setInputs((prevInputs) => {
                    const newInputs = [...prevInputs];
                    newInputs[index - 1] = "";
                    return newInputs;
                });
            } else {
                refs.current[index].focus();
                setInputs((prevInputs) => {
                    const newInputs = [...prevInputs];
                    newInputs[index] = "";
                    return newInputs;
                });
            }
        } else if (e.keyCode === 37 && index > 0) {
            // Handle left arrow key
            refs.current[index - 1].focus();
        } else if (e.keyCode === 39 && index < numInputs - 1) {
            // Handle right arrow key
            refs.current[index + 1].focus();
        }
    };
    
    return (
        <>
            {inputs.map((value, index) => (
                <Fragment key={index}>
                    <label htmlFor={index}></label>
                    <input
                        key={index}
                        type="text"
                        id={index}
                        autoFocus={index === 0}
                        pattern="[0-9]*"
                        value={value}
                        autoComplete="off"
                        onFocus={()=>seterror(false)}
                        className={`w-10 border-b mr-2 ${error?'border-[#C81720]':'border-[#52555D]'} bg-[#fff] outline-0 text-center text-xl font-normal text-[#000] otp-input`}
                        onChange={(e) => {
                            if (!/[^0-9]/g.test(e.target.value)) {
                                handleChange(e, index);
                            }
                        }}
                        onPaste={handlePaste}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                        ref={(el) => {(refs.current[index] = el)}}
                    />
                </Fragment>
            ))}
        </>
    );
};

export default OtpInputField;


